import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { obtenerUsuario } from "../redux/actions";
import axiosapi from "../config/axiosConfig";

const isProduction = process.env.NODE_ENV === "production";
const LOGIN_URL = isProduction
  ? "https://gestionterritoriallr.com.ar/"
  : "https://pxh0r724-5173.brs.devtunnels.ms/";

const Home = () => {
  const dispatch = useDispatch();
  const usuario = useSelector((state) => state.usuario);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    axiosapi
      .get("/api/profile", {
        withCredentials: true
      })
      .then(res => {
        if (res.data.usuario && res.data.autorizado) {
          dispatch(obtenerUsuario(res.data.usuario.email));
          setCargando(false);
        } else {
          localStorage.removeItem("session");
          window.location.href = LOGIN_URL;
        }
      })
      .catch(() => {
        localStorage.removeItem("session");
        window.location.href = LOGIN_URL;
      });
  }, [dispatch]);

  if (cargando || !usuario.id) {
    return (
      <div className="grid h-screen w-full place-items-center">
        <svg className="w-16 h-16 animate-spin text-gray-900/50" viewBox="0 0 64 64" fill="none">
          <path d="M32 3C35.8083 3 ... (spinner path) ..." stroke="currentColor" strokeWidth="5" />
        </svg>
      </div>
    );
  }

  return (
    <div>
      <div className="flex w-full h-screen bg-backgroundClaro justify-center items-center">
        <div className="grid grid-cols-2 md:grid-cols-4 justify-between gap-16">
          <Link to="/altaproducto">
            <button className=" py-3  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Alta de Productos</button>
          </Link>
          <Link to="/altaproveedor">
            <button className="  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Alta de Proveedor</button>
          </Link>
          <Link to="/altaobra">
            <button className="  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Alta de Obra</button>
          </Link>
          <Link to="/ingresos">
            <button className=" py-3  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Ingresos</button>
          </Link>
          <Link to="/salidas">
            <button className=" py-3 md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Salidas</button>
          </Link>
          <Link to="/prestamos">
            <button className=" py-3 md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Prestamos</button>
          </Link>
          <Link to="/devolucion">
            <button className=" py-3 md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Devolución</button>
          </Link>
          {usuario?.rol === "Super_Admin" && (
            <>
              <Link to="/autorizados">
                <button className="py-3 md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Autorizados</button>
              </Link>
              <Link to="/registro">
                <button className=" py-3 md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Usuarios</button>
              </Link>
              <Link to="/clientes">
                <button className=" py-3 md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Clientes</button>
              </Link>
              <Link to="/reportes">
                <button className=" py-3  md:text-4xl text-base font-bold w-40 h-16 md:w-52 md:h-32 bg-backgroundOscuro rounded-md text-textoClaro outline-none focus:ring-4 shadow-lg transform active:scale-75 transition-transform">Reportes</button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;